export class PetVitalsModel {
    pet_no: number
    tag0: string
    tag3: string
    tag4: string
    tag5: string
    tag2: string
    tag30: string
    tag31: string
    tag32: string
    tag33: string
    tag34: string
    tag26: string
    tag26bis: string
    tag27: string
    tag27bis: string
    tag28: string
    tag28bis: string
    tag29: string
    tag37: string
    tag38: string
    tag39: string
    tag40: string
    tag41: string
    tag42: string
    tag43: string
    tag44: string
    tag45: string
    tag46: string
    tag47: string

    _tag26: string
    _tag26bis: string
    _tag27: string
    _tag27bis: string
    _tag28: string
    _tag28bis: string

    constructor(
        pet_no: number,
        tag0: string,
        tag3: string,
        tag4: string,
        tag5: string,
        tag2: string,
        tag30: string,
        tag31: string,
        tag32: string,
        tag33: string,
        tag34: string,
        tag26: string,
        tag26bis: string,
        tag27: string,
        tag27bis: string,
        tag28: string,
        tag28bis: string,
        tag29: string,
        tag37: string,
        tag38: string,
        tag39: string,
        tag40: string,
        tag41: string,
        tag42: string,
        tag43: string,
        tag44: string,
        tag45: string,
        tag46: string,
        tag47: string,
    ) {
        this.pet_no = pet_no
        this.tag0 = tag0
        this.tag3 = tag3
        this.tag4 = tag4
        this.tag5 = tag5
        this.tag2 = tag2
        this.tag30 = tag30
        this.tag31 = tag31
        this.tag32 = tag32
        this.tag33 = tag33
        this.tag34 = tag34
        this.tag26 = tag26
        this.tag26bis = tag26bis
        this.tag27 = tag27
        this.tag27bis = tag27bis
        this.tag28 = tag28
        this.tag28bis = tag28bis
        this.tag29 = tag29
        this.tag37 = tag37
        this.tag38 = tag38
        this.tag39 = tag39
        this.tag40 = tag40
        this.tag41 = tag41
        this.tag42 = tag42
        this.tag43 = tag43
        this.tag44 = tag44
        this.tag45 = tag45
        this.tag46 = tag46
        this.tag47 = tag47
    }
}